import { getRequest, postRequest, putRequest } from '@bo-apis/axios';

const getMember = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-member`,
  });

const getMemberList = ({ form, pageable }) =>
  postRequest({
    url: 'api/v1/member/get-member-list',
    params: { ...pageable },
    data: { ...form },
  });

const getMemberAdditionalInfo = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-additional-info`,
  });

const getMemberUnusualItemList = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-unusual-item-list`,
  });

const getMemberDeliveryLocationList = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-location-list`,
  });

const saveMemberDetailData = (memberNumber, saveData) =>
  postRequest({
    url: `api/v1/member/${memberNumber}/save-detail-data`,
    data: { ...saveData },
  });

const issueTempPassword = (payload) =>
  postRequest({
    url: `api/v1/member/issue-temp-password`,
    data: { ...payload },
  });

const getCounselingMemberInfo = (loginId, cellNumber) =>
  postRequest({
    url: `api/v1/member/find-counseling-member-info`,
    data: { loginId, cellNumber },
  });

const getMemberDisplayingUnusualItemList = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-displaying-unusual-item-list`,
  });

const createMemberList = (payload) =>
  postRequest({
    url: `api/v1/member/save-member-list`,
    data: payload,
  });

const getCoMemberInfoList = async (siteNumber) =>
  await getRequest({
    url: `/api/v1/member/${siteNumber}/get-co-member-list`,
  });

const createCoMember = (siteNumber, changedData) =>
  postRequest({
    url: `api/v1/member/create-co-member-list`,
    data: {
      siteNumber,
      changedData,
    },
  });

const deleteCoMember = async (coUserIdList) =>
  await putRequest({
    url: `api/v1/member/delete-co-member-list`,
    data: {
      coUserIdList,
    },
  });

const saveCoMember = async (coUserId, coUserStatus) =>
  await putRequest({
    url: `api/v1/member/save-co-member`,
    data: {
      coUserId,
      coUserStatus,
    },
  });

const createTempPassword = async (coUserIdList) =>
  await postRequest({
    url: `api/v1/member/temp-password`,
    data: {
      coUserIdList,
    },
  });

const updateMemberLoginFailCnt = (payload) =>
  postRequest({
    url: `api/v1/member/update-member-login-fail-cnt`,
    data: payload,
  });

const updateCheckNameExcept = (payload) => 
postRequest({
  url: `api/v1/member/update-member-check-name-except`,
  data: payload,
});

const resetCellPhoneInfo = (memberNumber) => 
  postRequest({
    url: `api/v1/member/reset-cellphone-info`,
    params:  memberNumber,
  });

export default {
  getMember,
  getMemberList,
  getMemberAdditionalInfo,
  getMemberDeliveryLocationList,
  getMemberUnusualItemList,
  saveMemberDetailData,
  issueTempPassword,
  getCounselingMemberInfo,
  getMemberDisplayingUnusualItemList,
  createMemberList,
  getCoMemberInfoList,
  createCoMember,
  deleteCoMember,
  saveCoMember,
  createTempPassword,
  updateMemberLoginFailCnt,
  updateCheckNameExcept,
  resetCellPhoneInfo,
};
